import * as React from 'react';

const MobileTicketIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 232 320" {...props}>
        <style>
            {
                '\n        .mobile-ticket-illustration_svg__st0{fill:#dbdae3}.mobile-ticket-illustration_svg__st1{fill:#1e0a3c}.mobile-ticket-illustration_svg__st2{fill:#f05537}.mobile-ticket-illustration_svg__st4{fill:#324b8c}.mobile-ticket-illustration_svg__st5{fill:#fff}.mobile-ticket-illustration_svg__st6{fill:#c2c2cc}\n    '
            }
        </style>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st0"
                d="M.3 312.2C270.2 260.9 191 7 .3 4.2v308z"
            />
            <path
                className="mobile-ticket-illustration_svg__st0"
                d="M0 312.5V4h.2c23.8.3 46.6 4.6 67.7 12.6 19.9 7.5 37.9 18.2 53.5 31.8 15.1 13.1 27.3 28.3 36.4 45.2 9 16.9 14.5 34.6 16.1 52.7 1.6 17.6-.4 34.9-6.1 51.4-5.9 17.4-15.8 33.6-29.3 48.1-14.4 15.5-32.9 28.9-55 39.9-23.8 11.8-51.8 20.8-83.3 26.8H0zm.5-308V312c31.4-6 59.2-15 82.9-26.7 22-11 40.5-24.3 54.9-39.8 13.4-14.4 23.3-30.5 29.2-47.9 5.6-16.4 7.6-33.7 6-51.2-1.7-18.1-7.1-35.7-16.1-52.6-9-16.8-21.2-32-36.3-45C105.6 35.2 87.6 24.5 67.8 17 46.7 9.1 24.1 4.8.5 4.5z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M55.338 38.067l.331-.5 6.752 4.475-.332.5z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M52.992 46.666l.085-.594 6.93.982-.084.594z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M62.142 32.465l.516-.307 3.585 6.012-.515.307z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st2"
                d="M.2 228s25.9-19.4 31.7-31.3c5.8-12 7.6-25.4 10.9-35.9 3.2-10.5 22.1-40.6 25.7-64.9 3.6-24.3.4-35.5 2.2-37 1.8-1.5 16.3.4 16.7 25s0 51.8 0 51.8 93.5-71.1 100.1-75c6.5-4 10.1-4.7 12.7-2.2 2.5 2.5 3.6 6.2-5.1 13.4s-59.8 48.6-58.4 51.5 5.8 1.8 9.1-.7 68.9-51.5 75.8-53.7c6.9-2.2 13.8 1.8 7.3 10.1-6.5 8.3-75.4 64.2-75.1 67.1.4 2.9 1.5 3.2 5.1 2.2 3.6-1.1 59.1-45.7 63.5-45.7s9.8 4.7-.4 14.1c-10.1 9.4-59.1 55.4-58.7 58s4.7 1.1 4.7 1.1 48.9-23.2 54-19.2c5.1 4 1.5 6.9-1.8 9.4-3.2 2.6-134.7 82.3-152.7 97.2-13.7 11.3-51.5 38-67.2 49.3V228z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M79.6 205c-.2 0-.4-.1-.6-.3-.3-.3-.2-.8.1-1 6.1-5.3 11.1-11.8 14.6-19.1 3.2-6.9 4.8-14.4 4.6-21.9-.3-9.4-3.4-19-9.3-28.6-.2-.4-.1-.8.3-1 .3-.1.6-.1.8 0 8.1 6.7 15.7 14.1 22.6 22 6.2 7.3 10.8 14.1 13.6 20.3 3.5 7.8 4.2 14.6 2 20.3-.2.4-.6.5-1 .3-.3-.2-.4-.5-.4-.8 2.1-5.3 1.4-11.7-1.9-19.2-2.7-6.1-7.2-12.8-13.3-19.9-6-6.9-12.4-13.3-19.3-19.2 4.7 8.6 7.2 17.3 7.5 25.8.2 7.8-1.4 15.5-4.7 22.6-5.7 12.4-14.6 19.3-15 19.6-.3 0-.4.1-.6.1z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M203.8 221.7L130.6 241c-6.8 1.8-13.8-2.3-15.6-9.1L69.4 58.4c-1.8-6.8 2.3-13.8 9.1-15.6l73.2-19.3c6.8-1.8 13.8 2.3 15.6 9.1L213 206c1.7 6.9-2.4 13.9-9.2 15.7"
            />
        </g>
        <g>
            <path
                d="M164.6 220.9c-1 .3-1.5 1.2-1.2 2.2.3 1 1.2 1.5 2.2 1.2.9-.3 1.5-1.2 1.3-2.2-.3-.9-1.3-1.5-2.3-1.2.1 0 0 0 0 0m1.1 4c-1.3.4-2.6-.4-2.9-1.7-.4-1.3.4-2.6 1.7-2.9 1.3-.4 2.6.4 2.9 1.7.3 1.3-.4 2.6-1.7 2.9"
                fill="#cfced6"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st4"
                d="M116.7 224.8L74.5 64.5c-.1-.6.2-1.1.8-1.3l89.3-23.5c.6-.1 1.1.2 1.3.8L208 200.7c.1.6-.2 1.1-.8 1.3L118 225.5c-.6.2-1.2-.2-1.3-.7"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st5"
                d="M176.1 122.7c-1.1-3.9 3.5-6 3.5-6l-16-60.8-79.2 21 16 60.8s4.5-.5 5.7 3.6c1.2 3.9-3.3 5.5-3.3 5.5l20.7 77.5 79.2-21-20.7-77.6s-4.7 1.2-5.9-3z"
            />
        </g>
        <g>
            <circle
                className="mobile-ticket-illustration_svg__st5"
                cx={160.5}
                cy={52.4}
                r={0.8}
            />
        </g>
        <g>
            <circle
                className="mobile-ticket-illustration_svg__st5"
                cx={159.8}
                cy={49.7}
                r={0.8}
            />
        </g>
        <g>
            <circle
                className="mobile-ticket-illustration_svg__st5"
                cx={159}
                cy={47}
                r={0.8}
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M110.723 86.365l5.124-1.354 1.355 5.124-5.124 1.354z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M118.615 116.566l5.124-1.354 1.355 5.124-5.124 1.354z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M136.4 75.9l3.1 11.8 3.6-1 .9 3.4-8.1 2.1 1 3.9-4.5 1.2-1-3.9-.9-3.4 7.5-2-3.1-11.8-3 .8 2.1 7.9-8.5 2.3-1-3.9 4-1.1-1.1-4-4 1.1 1 3.6-4 1.1 1.1 4.3 4-1.1 1 3.6-5.1 1.4-3.1-11.6-11.8 3.1 3.1 11.8 8.5-2.3 1.9 7.3 3.9-1-1-3.6 4.5-1.2 1 3.6-4.5 1.2 1 3.9-12.4 3.2 5 19 11.8-3.1-3-11.3 4.7-1.2-1.1-4 4.5-1.2-.8-3.2 4.5-1.2.8 3.2-4.5 1.2 3.1 11.6-4.5 1.2-1-3.9-4 1.1 1.1 4 4-1.1 1 3.6 4.5-1.2-1-3.6 3.9-1 1 3.6 9-2.4-1.1-4-.9-3.6 7.9-2.1-2-7.7-3.9 1-.9-3.5v-.1l3.9-1-1.1-4-3.8 1-1.9-7.1 3.9-1-3.1-11.8-12.1 3.1zm-18.6 33.8l3.9-1 .8 3.2-4 1.1-.8-3.2.1-.1zm9.1 11.8l-7.9 2.1-2.2-8.1 7.9-2.1 2.2 8.1zm-18-36.3l7.9-2.1 2.1 8.1-7.9 2.1-2.1-8.1zm32.4 30.2l-1-3.7v-.3l-.9-3.5 8.8-2.3 1 3.6-3.9 1 1 3.9-5 1.3zm5.7-13.9l-4.3 1.1-1-3.6-3.9 1-1-3.9L145 94l1 3.7v.3l1 3.5zm2.1-18.2l-7.9 2.1-2.1-8.1 7.9-2.1 2.1 8.1z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M140.916 78.375l5.124-1.354 1.355 5.124-5.124 1.354z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M151.907 110.254l5.8-1.534 1.585 5.995-5.8 1.533z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st1"
                d="M110.454 98.998l4.06-1.073 1.023 3.867-4.06 1.073z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st4"
                d="M173.5 123.8c-.5.1-1-.1-1.1-.6-.1-.4.1-.9.6-1.1.4-.1.9.1 1.1.6.1.5-.1 1-.6 1.1z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st4"
                d="M170.2 124.7c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.2 1-.6 1.1zm-3.5.9c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1 1-.6 1.1zm-3.3.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6s-.2 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.2.9-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.1.9-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.5.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6s-.1.9-.6 1.1zm-3.4.8c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.5.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6s-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1 1-.6 1.1zm-3.3.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.5-.2 1-.6 1.1zm-3.5.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1 1-.6 1.1zm-3.4.9c-.5.2-1-.1-1.2-.6-.1-.5.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1.9-.6 1.1zm-3.3.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.4-.2.9-.6 1.1zm-3.5.9c-.5.2-1-.1-1.2-.6-.1-.4.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.2.5-.1.9-.6 1.1zm-3.3.8c-.5.2-1-.1-1.2-.6s.1-.9.6-1.1h.1c.4-.1.9.1 1.1.6.1.6-.2 1-.6 1.1z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st4"
                d="M109.1 140.8c-.5.1-1-.1-1.1-.6-.1-.4.1-.9.6-1.1.4-.1.9.1 1.1.6.1.5-.2 1-.6 1.1z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st2"
                d="M42.8 160.8c3.2-10.5 22.1-40.6 25.7-64.9 3.6-24.3.4-35.5 2.2-37 1.8-1.5 19.6 1 20 25.6s-1.3 50.7-1.3 50.7"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M165.1 158.2L123 169.9c-2 .5-4-.6-4.6-2.6l-1.1-3.9 45.7-12.7c2-.6 4.1.6 4.7 2.7v.1c.6 2.1-.6 4.1-2.6 4.7z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M147.7 151.2l-31.3 8.7-.8-3.1c-.4-1.3.4-2.7 1.7-3.1l28.9-8.1c1.5-.4 3 .4 3.4 1.9v.1c.4 1.7-.5 3.2-1.9 3.6z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M149.4 186.2l-21.8 5.9c-1.2.3-2.4-.4-2.7-1.5l-.6-2.3 23.9-6.5c1.2-.3 2.4.4 2.8 1.6v.1c.3 1.1-.4 2.4-1.6 2.7z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M138.9 181.1l-15.4 4.2-.5-1.8c-.2-.8.3-1.6 1-1.8l14-3.8c.8-.2 1.7.3 2 1.2v.1c.3.8-.2 1.7-1.1 1.9z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M154.5 204.7l-21.8 5.9c-1.2.3-2.4-.4-2.7-1.5l-.6-2.3 23.9-6.5c1.2-.3 2.4.4 2.8 1.6v.1c.2 1.2-.5 2.4-1.6 2.7z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M144 199.6l-15.4 4.2-.5-1.8c-.2-.8.3-1.6 1-1.8l14-3.8c.8-.2 1.7.3 2 1.2v.1c.2.8-.3 1.7-1.1 1.9z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M189.4 195.2l-22.2 6.1c-1.2.3-2.4-.4-2.7-1.5l-.6-2.3 24.3-6.6c1.2-.3 2.4.4 2.8 1.6v.1c.3 1-.4 2.2-1.6 2.6z"
            />
        </g>
        <g>
            <path
                className="mobile-ticket-illustration_svg__st6"
                d="M178.9 190.1l-15.8 4.3-.5-1.8c-.2-.8.3-1.6 1-1.8l14.5-3.9c.8-.2 1.7.3 2 1.2v.1c.2.8-.4 1.7-1.2 1.9z"
            />
        </g>
    </svg>
);

MobileTicketIllustrationSvg.displayName = 'MobileTicketIllustrationSvg';
export default MobileTicketIllustrationSvg;
